import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

import SEO from "../components/seo"
import Layout from "../components/layout"
import Sidebar from "../components/sidebar"

import BreadCrumbs from "../components/BreadCrumbs"
import TableOfContent from "../components/TableOfContent"
import SectionSummary from "../components/SectionSummary"

import IndexedTitle from "../components/post/IndexedTitle"
import Message from "../components/post/Message"
import ArrowedLink from "../components/post/ArrowedLink"
import ApiMethod from "../components/post/ApiMethod"
import ApiObject from "../components/post/ApiObject"
import Table from "../components/post/Table"
import ColoredText from "../components/post/ColoredText"
import Image from "../components/post/Image"
import ApiMessage from "../components/post/ApiMessage"
import CodeExample from "../components/api/CodeExample"
import ObjectsTable from "../components/api/ObjectsTable"

import TwoColumns from "../components/TwoColumns"

import API from "../components/api/"

import { Context } from "../components/Context"

import docPostStyles from "./doc-post.module.css"

const shortcodes = { 
  SectionSummary, 
  IndexedTitle, 
  Message, 
  ArrowedLink, 
  ApiMethod, 
  ApiObject, 
  Table, 
  API, 
  ColoredText, 
  Image,
  ApiMessage,
  CodeExample,
  ObjectsTable,
  TwoColumns 
}

export default function DocPost({ data }) {
    const { mdx } = data
    // check how data changes on redirect

    const [context, setContext] = useState(null)
  
    // basicaly we double check redirect from / to /api-reference/transcoding/
    // if (mdx.fields.slug === '/'){
    //   mdx.fields.slug = '/api-reference/transcoding/'
    // }

    // console.log("mdx.fields.slug in doc-post.js: ", mdx.fields.slug)

    const [ currentPage, setCurrentPage ] = useState(mdx.fields.slug)  

    useEffect(() => {
      setCurrentPage(mdx.fields.slug )
  }, [mdx.fields.slug])        

    return (
        <Layout>
            <SEO title={mdx.frontmatter.post_title} description={mdx.excerpt} />

            <Context.Provider value={[context, setContext]}>

              <Sidebar submenuDataSourceName={mdx.frontmatter.data_json} postLink={currentPage} />

              <div className={docPostStyles.article}>       
                <div className={docPostStyles.container}>    

                    <TableOfContent postLink={currentPage} />

                    <div className={docPostStyles.body}>
                      <BreadCrumbs postLink={currentPage} />     
                      <h1>{mdx.frontmatter.post_title}</h1>
                      <MDXProvider components={shortcodes}>
                        <MDXRenderer>{mdx.body}</MDXRenderer>
                      </MDXProvider>       
                    </div> 

                </div>        
              </div>
                        
              

            </Context.Provider>

            <div className={docPostStyles.mobileModeTracker} id="mobile-mode"></div>

        </Layout>
    )
}

export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        post_title
        data_json
      }
      fields {
        slug
      }      
      excerpt
      rawBody
    }
  }
`